// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28t4o","content":"styles_content__1YNoz","row":"styles_row__2czq3","footer":"styles_footer__3l-_N","phraseLength":"styles_phraseLength__3m_dh"};